import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import Login from "./pages/login";
import Home from "./pages/Home";
import AdminDashboard from "./pages/AdminDashboard";
import AddUser from "./pages/addUser";
import PrivateRoute from "./components/PrivateRoute";
import DealerDetails from "./pages/DealerDetails";
import UserSales from "./pages/UserSales";
import AddDealer from "./pages/admin/AddDealer";
import DealerRewards from "./pages/admin/DealerRewards";
import ManageAdmins from "./pages/admin/ManageAdmins";
import GlobalRewards from "./pages/admin/GlobalRewards";

function App() {
  const isLoggedIn = localStorage.getItem("isLoggedIn") === "true";

  return (
    <BrowserRouter>
      <Routes>
        {/* Login - redirect if already logged in */}
        <Route
          path="/"
          element={
            isLoggedIn ? <Navigate to="/admin-dashboard" replace /> : <Login />
          }
        />

        {/* Public */}
        <Route path="/add-user" element={<AddUser />} />

        {/* Protected */}
        <Route
          path="/home"
          element={
            <PrivateRoute>
              <Home />
            </PrivateRoute>
          }
        />

        <Route
          path="/admin-dashboard"
          element={
            <PrivateRoute>
              <AdminDashboard />
            </PrivateRoute>
          }
        />

        <Route
          path="/admin/add-dealer"
          element={
            <PrivateRoute>
              <AddDealer />
            </PrivateRoute>
          }
        />

        <Route
          path="/admin/manage-admins"
          element={
            <PrivateRoute>
              <ManageAdmins />
            </PrivateRoute>
          }
        />

        <Route
          path="/admin/global-rewards"
          element={
            <PrivateRoute>
              <GlobalRewards />
            </PrivateRoute>
          }
        />

        <Route
          path="/dealer/:dealerId/rewards"
          element={
            <PrivateRoute>
              <DealerRewards />
            </PrivateRoute>
          }
        />

        <Route
          path="/dealer-details/:dealerId"
          element={
            <PrivateRoute>
              <DealerDetails />
            </PrivateRoute>
          }
        />

        <Route
          path="/admin/user-sales/:userId"
          element={
            <PrivateRoute>
              <UserSales />
            </PrivateRoute>
          }
        />

        {/* Catch-all */}
        <Route
          path="*"
          element={<Navigate to={isLoggedIn ? "/admin-dashboard" : "/"} replace />}
        />
      </Routes>
    </BrowserRouter>
  );
}

export default App;